export const mockBlogPosts = [];

// Retail liquor stores (L2) — updated 20th May 2026
export const retailStores = [
  { id: 1, name: "Lakeforest Wines", city: "Gurgaon", area: "Inayatpur (Sector 18)" },
  { id: 2, name: "Gtown Wines", city: "Gurgaon", area: "Kataria Chowk" },
  { id: 3, name: "Maha Laxmi Wines", city: "Faridabad", area: "Neemka" },
  { id: 4, name: "Time For Wine", city: "Gurgaon", area: "Sector 86 (Okasa)" },
  { id: 5, name: "Liquor Point", city: "Gurgaon", area: "Sector 51" },
  { id: 6, name: "Jaquar", city: "Gurgaon", area: "Sector 29" },
  { id: 7, name: "Firewater", city: "Gurgaon", area: "Sector 47" },
  { id: 8, name: "Scotchland", city: "Gurgaon", area: "Sector 73" },
  { id: 9, name: "Liquor Point", city: "Gurgaon", area: "Indra Colony" },
  { id: 10, name: "Gtown Wines", city: "Gurgaon", area: "Space Mall" },
  { id: 11, name: "Gtown Wines", city: "Gurgaon", area: "Kulture BYOB, Wembley Estate" },
  { id: 12, name: "Rajesh Wine", city: "Gurgaon", area: "Sector 103" },
  { id: 13, name: "Gtown Wines", city: "Gurgaon", area: "Malibu Town" },
  { id: 14, name: "Gtown Wines", city: "Gurgaon", area: "Krishna Chowk" },
  { id: 15, name: "Gtown Wines", city: "Gurgaon", area: "Sector 44" },
  { id: 16, name: "Gtown Wines", city: "Faridabad", area: "Badarpur Border" },
  { id: 17, name: "Scotchtap", city: "Gurgaon", area: "Fish Market" },
  { id: 18, name: "Maha Laxmi Wines", city: "Faridabad", area: "Metro Mor" },
  { id: 19, name: "Liquor Point", city: "Gurgaon", area: "Sector 45" },
  { id: 20, name: "Liquor Point", city: "Gurgaon", area: "Bass Valley" },
  { id: 21, name: "Star Wine", city: "Gurgaon", area: "Super Mart One" },
  { id: 22, name: "Surender Wines", city: "Gurgaon", area: "Near Karma Lakelands" },
  { id: 23, name: "Taste of Barrels", city: "Gurgaon", area: "DLF Phase 3" },
  { id: 24, name: "Time For Wine", city: "Gurgaon", area: "Sector 109 (Bajghera)" },
  { id: 25, name: "Vintage Wines", city: "Gurgaon", area: "Vatika Chowk" },
  { id: 26, name: "Discovery", city: "Gurgaon", area: "Sector 32" },
  { id: 27, name: "Time For Wine", city: "Gurgaon", area: "Sector 102" },
  { id: 28, name: "Liquor Fort", city: "Gurgaon", area: "Don Jon" },
  { id: 29, name: "Gtown Wines", city: "Gurgaon", area: "Pace City" },
  { id: 30, name: "Discovery", city: "Gurgaon", area: "Sector 57 (Hong Kong Bazaar)" },
  { id: 31, name: "Time For Wine", city: "Gurgaon", area: "Sector 114 (Bajghera)" },
  { id: 32, name: "Discovery", city: "Gurgaon", area: "Garden Estate" },
  { id: 33, name: "Liquor Mart", city: "Gurgaon", area: "Palda" },
  { id: 34, name: "Star Wine", city: "Gurgaon", area: "Super Mart 2 (DLF Phase 5)" },
  { id: 35, name: "Discovery", city: "Gurgaon", area: "Jharsa Chowk" },
  { id: 36, name: "Daily Dose", city: "Gurgaon", area: "Westin" },
  { id: 37, name: "Daily Dose", city: "Gurgaon", area: "DLF Phase 1" },
  { id: 38, name: "Daily Dose", city: "Gurgaon", area: "Sahara Mall" },
  { id: 39, name: "Time For Wine", city: "Gurgaon", area: "Sector 17/18 Road" },
  { id: 40, name: "Time For Wine", city: "Gurgaon", area: "Puri" },
  { id: 41, name: "Liquor Hub", city: "Gurgaon", area: "Adjoining Kohiba" },
  { id: 42, name: "Discovery", city: "Gurgaon", area: "Central Plaza (Golf Course Rd)" },
  { id: 43, name: "Time For Wine", city: "Gurgaon", area: "Sector 90 Chowk" },
  { id: 44, name: "Gtown Wines", city: "Gurgaon", area: "CAG Farm (Hero Honda Chowk)" },
  { id: 45, name: "Maha Laxmi Wines", city: "Faridabad", area: "Discovery Branch" },
  { id: 46, name: "Lakeforest Wines", city: "Gurgaon", area: "Jalsa Retail" },
  { id: 47, name: "Maha Laxmi Wines", city: "Faridabad", area: "Jaat Chowk" },
  { id: 48, name: "Dagar Wines", city: "Gurgaon", area: "KR Mangalam (Sohna Rd)" },
  { id: 49, name: "Scotchtap", city: "Gurgaon", area: "Sector 22" },
  { id: 50, name: "Scotchtap", city: "Faridabad", area: "BPTC Chowk" },
  { id: 51, name: "Shyam Wine", city: "Gurgaon", area: "Subhash Chowk" },
  { id: 52, name: "Discovery", city: "Gurgaon", area: "Sector 59 (Lemon Tree/Bora Bora)" },
  { id: 53, name: "Gtown Wines", city: "Gurgaon", area: "Ulawas" },
  { id: 54, name: "Scotchtap", city: "Gurgaon", area: "Dhudhahera Border" },
  { id: 55, name: "Scotchtap", city: "Gurgaon", area: "Bus Stand" },
  { id: 56, name: "Scotchtap", city: "Gurgaon", area: "Telephone Exchange" },
  { id: 57, name: "Gtown Wines", city: "Gurgaon", area: "Sector 21 (Hide by Reset)" },
  { id: 58, name: "Firewater", city: "Gurgaon", area: "Sector 58" },
  { id: 59, name: "Lakeforest Wines", city: "Gurgaon", area: "DLF Phase IV (Hamilton Court)" },
  { id: 60, name: "Lakeforest Wines", city: "Gurgaon", area: "Sector 29 (Leisure Valley)" },
  { id: 61, name: "Firewater", city: "Gurgaon", area: "Talab, Gurgaon-Faridabad Road" },
  { id: 62, name: "Scotchtap", city: "Gurgaon", area: "Jawala Mill" },
  { id: 63, name: "Discovery", city: "Gurgaon", area: "Mehrauli Border" },
  { id: 64, name: "Liquor Point", city: "Gurgaon", area: "Sector 82 (Vatika Road)" },
  { id: 65, name: "Gtown Wines", city: "Gurgaon", area: "Wazirabad Mandi" },
  { id: 66, name: "Scotchtap", city: "Faridabad", area: "Surajkund" },
  { id: 67, name: "Scotchtap", city: "Faridabad", area: "Sector 21" },
  { id: 68, name: "Scotchtap", city: "Faridabad", area: "Sector 28" },
  { id: 69, name: "Gtown Wines", city: "Gurgaon", area: "Ebowla Rooftop, Sector 39" },
  { id: 70, name: "ADS Spirits", city: "Gurgaon", area: "Electronic City" },
  { id: 71, name: "Discovery", city: "Gurgaon", area: "Ghata" },
  { id: 72, name: "Scotchtap", city: "Faridabad", area: "World Street" },
  { id: 73, name: "Scotchland", city: "Gurgaon", area: "Sector 75" },
  { id: 74, name: "Discovery", city: "Gurgaon", area: "Sector 42 (Reset)" },
  { id: 75, name: "Scotchtap", city: "Faridabad", area: "Ankhir Chowk" },
  { id: 76, name: "Maha Laxmi Wines", city: "Faridabad", area: "Bajrang Chowk" },
  { id: 77, name: "G Town", city: "Gurgaon", area: "Sector 31" },
  { id: 78, name: "Liquor Fort", city: "Gurgaon", area: "Sector 56 (Huda Market)" },
  { id: 79, name: "Signa", city: "Gurgaon", area: "Machan, Sector 29" },
  { id: 80, name: "Firewater", city: "Gurgaon", area: "Sector 38" },
  { id: 81, name: "Firewater", city: "Faridabad", area: "Sector 16" },
  { id: 82, name: "Kanak Wines", city: "Gurgaon", area: "Rajeev Chowk" },
  { id: 83, name: "ADS Spirits", city: "Gurgaon", area: "Ambience Island (Sector 24)" },
  { id: 84, name: "ADS Spirits", city: "Gurgaon", area: "Cyber City (Sector 24)" },
  { id: 85, name: "ADS Spirits", city: "Gurgaon", area: "DLF Phase 2 (Sector 25)" },
  { id: 86, name: "Discovery", city: "Gurgaon", area: "Horizon Centre" },
  { id: 87, name: "ADS Spirits", city: "Gurgaon", area: "Moulsari Avenue" },
  { id: 88, name: "Jagdish Wines", city: "Gurgaon", area: "Medanta (Dakotta BYOB)" },
  { id: 89, name: "Gtown Wines", city: "Gurgaon", area: "Sector 40" },
  { id: 90, name: "Gtown Wines", city: "Gurgaon", area: "Vatika City" },
  { id: 91, name: "Gtown Wines", city: "Gurgaon", area: "Sector 99 (Ebowla Expressway)" },
  { id: 92, name: "Lakeforest Wines", city: "Gurgaon", area: "Jalsa Wholesale" },
  { id: 93, name: "ADS Spirits", city: "Gurgaon", area: "Hyatt Place (Sector 18)" },
  { id: 94, name: "Firewater", city: "Faridabad", area: "Gopichand" },
  { id: 95, name: "Vintage Wines", city: "Gurgaon", area: "HaCha, Golf Course Ext Rd" },
  { id: 96, name: "Firewater", city: "Faridabad", area: "Charmwood" },
  { id: 97, name: "Firewater", city: "Gurgaon", area: "Gwal Pahari" },
  { id: 98, name: "Liquor Fort", city: "Gurgaon", area: "Sector 54 (Golf Course Rd)" },
  { id: 99, name: "Liquor Fort", city: "Gurgaon", area: "Kokina, Sector 66" },
  { id: 100, name: "Theka Janab Wines", city: "Gurgaon", area: "Sector 30 (Signature Tower)" },
  { id: 101, name: "Gtown Wines", city: "Gurgaon", area: "The Bristol" },
  { id: 102, name: "Ministry of Spirits", city: "Gurgaon", area: "Sector 27 (DLF Phase IV)" },

  // Goa — added 29 Aug 2026 (132 outlets)
  { id: 103, name: "Oxford Arcade", city: "Goa", area: "Anjuna" },
  { id: 104, name: "Goodluck Wine", city: "Goa", area: "Anjuna" },
  { id: 105, name: "Savitri Wine", city: "Goa", area: "Anjuna" },
  { id: 106, name: "Ice & Spice Wine", city: "Goa", area: "Arambol" },
  { id: 107, name: "Bobby Wine", city: "Goa", area: "Arpora" },
  { id: 108, name: "Rasna Wine", city: "Goa", area: "Arpora" },
  { id: 109, name: "The Locals Wine Store", city: "Goa", area: "Arpora" },
  { id: 110, name: "Cio Wines", city: "Goa", area: "Arpora" },
  { id: 111, name: "D'Souza Wine", city: "Goa", area: "Ashvem" },
  { id: 112, name: "Govekar Wines", city: "Goa", area: "Assagaon" },
  { id: 113, name: "Yesh Wines", city: "Goa", area: "Assagaon" },
  { id: 114, name: "DJ Wines", city: "Goa", area: "Assagaon" },
  { id: 115, name: "Raju Wine", city: "Goa", area: "Baga" },
  { id: 116, name: "Pritesh Wines", city: "Goa", area: "Baga" },
  { id: 117, name: "Radhakrishna Wines", city: "Goa", area: "Baga" },
  { id: 118, name: "Ashish Wines", city: "Goa", area: "Baga" },
  { id: 119, name: "Goa Liquor Mart", city: "Goa", area: "Baga" },
  { id: 120, name: "Goa Wine Mart", city: "Goa", area: "Baingini" },
  { id: 121, name: "Salkar Wine", city: "Goa", area: "Calangute" },
  { id: 122, name: "Lovely Town Liquor", city: "Goa", area: "Calangute" },
  { id: 123, name: "Manguesh Wine", city: "Goa", area: "Calangute" },
  { id: 124, name: "Unlimited Liquor", city: "Goa", area: "Calangute" },
  { id: 125, name: "Divkar Wine", city: "Goa", area: "Calangute" },
  { id: 126, name: "Susegado Wine", city: "Goa", area: "Calangute" },
  { id: 127, name: "Macvel Wine", city: "Goa", area: "Calangute" },
  { id: 128, name: "24 Karate", city: "Goa", area: "Calangute" },
  { id: 129, name: "R K Wine", city: "Goa", area: "Calangute" },
  { id: 130, name: "Capital Wine", city: "Goa", area: "Calangute" },
  { id: 131, name: "Newtons", city: "Goa", area: "Calangute" },
  { id: 132, name: "Saira Wine", city: "Goa", area: "Calangute" },
  { id: 133, name: "Yatikas Star Wine", city: "Goa", area: "Calangute" },
  { id: 134, name: "Arold", city: "Goa", area: "Calangute" },
  { id: 135, name: "Dorothi", city: "Goa", area: "Calangute" },
  { id: 136, name: "Pratik Wine", city: "Goa", area: "Calangute" },
  { id: 137, name: "Aarviaan Liquors", city: "Goa", area: "Calangute" },
  { id: 138, name: "77 Liquor", city: "Goa", area: "Calangute" },
  { id: 139, name: "Baga Wines", city: "Goa", area: "Calangute" },
  { id: 140, name: "U K Wines", city: "Goa", area: "Calangute" },
  { id: 141, name: "Ambika Wines", city: "Goa", area: "Calangute" },
  { id: 142, name: "Lawande Wine", city: "Goa", area: "Candolim" },
  { id: 143, name: "Menezes Enterprise", city: "Goa", area: "Candolim" },
  { id: 144, name: "Shree DG Mart", city: "Goa", area: "Caranzalem" },
  { id: 145, name: "D S Wine", city: "Goa", area: "Chodem" },
  { id: 146, name: "Ayush Wine", city: "Goa", area: "Dhargal" },
  { id: 147, name: "Vagheri Wine", city: "Goa", area: "Keri" },
  { id: 148, name: "Vedangh Wine", city: "Goa", area: "Kiranpani" },
  { id: 149, name: "Big Boyz Liquor World", city: "Goa", area: "Mandrem" },
  { id: 150, name: "PVV", city: "Goa", area: "Mapusa" },
  { id: 151, name: "Lanjekar Wines", city: "Goa", area: "Mapusa" },
  { id: 152, name: "Hard Taste", city: "Goa", area: "Morjim" },
  { id: 153, name: "Babloo Wine", city: "Goa", area: "Morjim" },
  { id: 154, name: "Subhi Wine", city: "Goa", area: "Morjim" },
  { id: 155, name: "SS Wine", city: "Goa", area: "Palyem" },
  { id: 156, name: "Kop de Goa", city: "Goa", area: "Palyem" },
  { id: 157, name: "World of Wine", city: "Goa", area: "Panjim" },
  { id: 158, name: "Casa Bareto", city: "Goa", area: "Panjim" },
  { id: 159, name: "Salude Wine Mart", city: "Goa", area: "Panjim" },
  { id: 160, name: "Anupama Wines", city: "Goa", area: "Panjim" },
  { id: 161, name: "Adi's Liquor Shop", city: "Goa", area: "Panjim" },
  { id: 162, name: "SH Enterprises", city: "Goa", area: "Panjim" },
  { id: 163, name: "Madhuchandra", city: "Goa", area: "Parra" },
  { id: 164, name: "Sangles Wines", city: "Goa", area: "Perenem" },
  { id: 165, name: "Delfinos", city: "Goa", area: "Porvarim" },
  { id: 166, name: "Aniruth Wines", city: "Goa", area: "Porvarim" },
  { id: 167, name: "D'Silva Wine", city: "Goa", area: "Santa Cruz" },
  { id: 168, name: "Bhagwati Super Market", city: "Goa", area: "Siolim" },
  { id: 169, name: "Once Upon a Bottle", city: "Goa", area: "Siolim" },
  { id: 170, name: "Disha Wine", city: "Goa", area: "Siolim" },
  { id: 171, name: "Khedekar Wines", city: "Goa", area: "Siolim" },
  { id: 172, name: "Amancio", city: "Goa", area: "Siolim" },
  { id: 173, name: "Savitri Wine", city: "Goa", area: "Vagator" },
  { id: 174, name: "Top Notch", city: "Goa", area: "Vagator" },
  { id: 175, name: "Sose Wines", city: "Goa", area: "Anjuna" },
  { id: 176, name: "Karni Wine", city: "Goa", area: "Anjuna" },
  { id: 177, name: "Gopinath Wines", city: "Goa", area: "Assagaon" },
  { id: 178, name: "Funter Wine", city: "Goa", area: "Calangute" },
  { id: 179, name: "Disha Wine", city: "Goa", area: "Calangute" },
  { id: 180, name: "The Liquor House", city: "Goa", area: "Calangute" },
  { id: 181, name: "White House Wine", city: "Goa", area: "Keri" },
  { id: 182, name: "Sanvi Wine", city: "Goa", area: "Morjim" },
  { id: 183, name: "Tuka Wine", city: "Goa", area: "Panjim" },
  { id: 184, name: "Booze Me More", city: "Goa", area: "Sangolda" },
  { id: 185, name: "Desai Wine", city: "Goa", area: "Sangolda" },
  { id: 186, name: "P & P Wine", city: "Goa", area: "Balli" },
  { id: 187, name: "Golden Anchor", city: "Goa", area: "Benalium" },
  { id: 188, name: "Infinity Liquor", city: "Goa", area: "Benalium" },
  { id: 189, name: "Mr. B's Wines", city: "Goa", area: "Benalium" },
  { id: 190, name: "Joe Liquor", city: "Goa", area: "Benalium" },
  { id: 191, name: "Galaxy Wine", city: "Goa", area: "Benalium" },
  { id: 192, name: "Vini Cola Spirits", city: "Goa", area: "Borda" },
  { id: 193, name: "Premdutta", city: "Goa", area: "Cancona" },
  { id: 194, name: "Surat Wine Shop", city: "Goa", area: "Cancona" },
  { id: 195, name: "Shubham Wine", city: "Goa", area: "Cancona" },
  { id: 196, name: "Kritisha Wine", city: "Goa", area: "Cancona" },
  { id: 197, name: "Red Rose", city: "Goa", area: "Cancona" },
  { id: 198, name: "Alina Wine", city: "Goa", area: "Cancona" },
  { id: 199, name: "Desai Liquors", city: "Goa", area: "Carmona" },
  { id: 200, name: "Kaarbo Wine", city: "Goa", area: "Cavalossim" },
  { id: 201, name: "Star Wine", city: "Goa", area: "Colva" },
  { id: 202, name: "Vaz Enterprise", city: "Goa", area: "Colva" },
  { id: 203, name: "The Liquor Store", city: "Goa", area: "Colva" },
  { id: 204, name: "Hegde Wines", city: "Goa", area: "Colva" },
  { id: 205, name: "High Spirits", city: "Goa", area: "Colva" },
  { id: 206, name: "Brothers Wines", city: "Goa", area: "Colva" },
  { id: 207, name: "Liquor Club", city: "Goa", area: "Fatorda" },
  { id: 208, name: "Fortune Wine", city: "Goa", area: "Kharabend" },
  { id: 209, name: "Drink Inc Wines", city: "Goa", area: "Majorda" },
  { id: 210, name: "Rex Wines", city: "Goa", area: "Majorda" },
  { id: 211, name: "K-4 Super Market", city: "Goa", area: "Mobor" },
  { id: 212, name: "Brysons Wines", city: "Goa", area: "Mobor" },
  { id: 213, name: "Gaurish Liquor", city: "Goa", area: "Ponda" },
  { id: 214, name: "Liquor Hub", city: "Goa", area: "Varca" },
  { id: 215, name: "Honey Liquor", city: "Goa", area: "Varca" },
  { id: 216, name: "Varca Mini Mart", city: "Goa", area: "Varca" },
  { id: 217, name: "Sebstain", city: "Goa", area: "Vasco" },
  { id: 218, name: "Montiero", city: "Goa", area: "Vasco" },
  { id: 219, name: "Daren Wine", city: "Goa", area: "Vasco" },
  { id: 220, name: "Bandodkar Wine", city: "Goa", area: "Betalbatim" },
  { id: 221, name: "Hegde Wine", city: "Goa", area: "Colva" },
  { id: 222, name: "Vinil Wine", city: "Goa", area: "Colva" },
  { id: 223, name: "Sai Wine", city: "Goa", area: "Colva" },
  { id: 224, name: "AR Super Market", city: "Goa", area: "Gogal" },
  { id: 225, name: "Asha Wines", city: "Goa", area: "Mangueshi" },
  { id: 226, name: "Gonson Wines", city: "Goa", area: "Margao" },
  { id: 227, name: "Booze Bodega", city: "Goa", area: "Margao" },
  { id: 228, name: "Liquor Club", city: "Goa", area: "Margao" },
  { id: 229, name: "Bandekar Wines", city: "Goa", area: "Ponda" },
  { id: 230, name: "Deep Wines", city: "Goa", area: "Ponda" },
  { id: 231, name: "Pavitra Wines", city: "Goa", area: "Ponda" },
  { id: 232, name: "Shirodkar Wines", city: "Goa", area: "Ponda" },
  { id: 233, name: "Royal Spirits", city: "Goa", area: "Utorda" },
  { id: 234, name: "Roy Wine", city: "Goa", area: "Varca" },

  // Panchkula — Scotchtap only (as of 29 Aug 2026)
  { id: 235, name: "Scotchtap", city: "Panchkula", area: "Multiple Outlets" }
];

// HORECA outlets — 40 outlets where we are currently SELLING (Existing list)
export const horecaOutlets = [
  { id: 1, name: "Koca", city: "Gurgaon", area: "" },
  { id: 2, name: "DLF Club 4", city: "Gurgaon", area: "DLF" },
  { id: 3, name: "DLF Club 3", city: "Gurgaon", area: "DLF" },
  { id: 4, name: "DLF Club 5", city: "Gurgaon", area: "DLF" },
  { id: 5, name: "DLF Club Vita", city: "Gurgaon", area: "DLF" },
  { id: 6, name: "DLF Club Ultima", city: "Gurgaon", area: "DLF" },
  { id: 7, name: "One8 Commune", city: "Gurgaon", area: "Golf Course Road" },
  { id: 8, name: "Bellagio", city: "Gurgaon", area: "" },
  { id: 9, name: "Avatar", city: "Gurgaon", area: "" },
  { id: 10, name: "Sutra", city: "Gurgaon", area: "" },
  { id: 11, name: "Poiz", city: "Gurgaon", area: "" },
  { id: 12, name: "Hyatt", city: "Gurgaon", area: "" },
  { id: 13, name: "Zuvaah", city: "Gurgaon", area: "" },
  { id: 14, name: "Encanto", city: "Gurgaon", area: "" },
  { id: 15, name: "Karma Lakelands", city: "Gurgaon", area: "" },
  { id: 16, name: "The Hyve", city: "Gurgaon", area: "" },
  { id: 17, name: "Romeo Lane", city: "Gurgaon", area: "" },
  { id: 18, name: "Swagath Bar", city: "Gurgaon", area: "" },
  { id: 19, name: "Zorro", city: "Gurgaon", area: "" },
  { id: 20, name: "Diego", city: "Gurgaon", area: "" },
  { id: 21, name: "Synx", city: "Gurgaon", area: "" },
  { id: 22, name: "Circe", city: "Gurgaon", area: "" },
  { id: 23, name: "Imperfecto", city: "Gurgaon", area: "M2K" },
  { id: 24, name: "One Door Down", city: "Gurgaon", area: "" },
  { id: 25, name: "Banng", city: "Gurgaon", area: "" },
  { id: 26, name: "Spezia Bistro", city: "Gurgaon", area: "" },
  { id: 27, name: "Red Fox by Lemon Tree", city: "Gurgaon", area: "" },
  { id: 28, name: "TGI Fridays", city: "Gurgaon", area: "" },
  { id: 29, name: "Masala Synergy", city: "Gurgaon", area: "" },
  { id: 30, name: "Radisson 29", city: "Gurgaon", area: "Sector 29" },
  { id: 31, name: "Farzi", city: "Gurgaon", area: "" },
  { id: 32, name: "Beer Circle", city: "Gurgaon", area: "" },
  { id: 33, name: "Ilios", city: "Gurgaon", area: "" },
  { id: 34, name: "Reflex", city: "Gurgaon", area: "" },
  { id: 35, name: "Barbeque Times", city: "Gurgaon", area: "M2K" },
  { id: 36, name: "Gonzo / Shift", city: "Gurgaon", area: "" },
  { id: 37, name: "Martinis", city: "Gurgaon", area: "" },
  { id: 38, name: "ZYXX", city: "Gurgaon", area: "" },
  { id: 39, name: "Clarens (Kai Room)", city: "Gurgaon", area: "Sector 29" },
  { id: 40, name: "Angry Sardar", city: "Gurgaon", area: "" }
];

// Retail partner brands — logos shown under Liquor Stores tab
// `cities` = list of cities where this brand stocks NoBelly. Used by FindUs
// to filter the logo strip when the visitor picks a specific city chip.
// `logo` field = URL to actual brand logo image. If null, falls back to letter `mark`.
export const retailerBrands = [
  {
    id: 1,
    slug: "toms-wine",
    name: "Tom's Wine",
    mark: "T",
    tagline: "Wine & Liquor",
    cities: ["Goa"],
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/4pc8kjw5_Tom%27s%20wine%20logo.jpg"
  },
  {
    id: 2,
    slug: "scotchtap",
    name: "Scotchtap",
    mark: "S",
    tagline: "Liquors Pvt. Ltd.",
    cities: ["Gurgaon", "Faridabad", "Panchkula"],
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/v0qqa2tw_Scotchtap%20Logo.jpg"
  },
  {
    id: 3,
    slug: "tfw",
    name: "Time For Wine",
    mark: "TFW",
    tagline: "Fine Selection",
    cities: ["Gurgaon"],
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/7xey0n5g_TFW%20Logo.png"
  },
  {
    id: 4,
    slug: "ads",
    name: "ADS Spirits",
    mark: "ADS",
    tagline: "Premium Cellar",
    cities: ["Gurgaon"],
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/orbwo5tc_ADS%20Logo.png"
  },
  {
    id: 5,
    slug: "firewater",
    name: "Firewater",
    mark: "F",
    tagline: "Best In Town",
    cities: ["Gurgaon", "Faridabad"],
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/befkipcq_Firewater%20Logo.png"
  },
  {
    id: 6,
    slug: "gtown",
    name: "Gtown Wines",
    mark: "G",
    tagline: "Wines & Beers",
    cities: ["Gurgaon"],
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/0y7yfesr_Gtown%20Wines%20Logo.png"
  },
  {
    id: 7,
    slug: "discovery",
    name: "Discovery Wines",
    mark: "D",
    tagline: "Fine Spirits",
    cities: ["Gurgaon"],
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/mvi6vrcm_Discovery%20Wines%20Logo.jpg"
  }
];

// HORECA partner brands — logos shown under Bars · Restaurants · Hotels tab
// Add more entries as new logos are uploaded.
export const horecaBrands = [
  {
    id: 1,
    slug: "one8-commune",
    name: "one8 Commune",
    tagline: "Restaurant · Bar",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/00nxxwf0_One%208%20Logo.jpg"
  },
  {
    id: 2,
    slug: "koca",
    name: "Koca",
    tagline: "Fine Dining",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/9dhor7ds_Koca%20Logo.jpg"
  },
  {
    id: 3,
    slug: "hyatt-place",
    name: "Hyatt Place",
    tagline: "Gurgaon · Udyog Vihar",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/mrfgxzie_Hyatt%20Logo.jpg"
  },
  {
    id: 4,
    slug: "bangg",
    name: "Bangg",
    tagline: "Restaurant · Bar",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/l5ipx3ky_Bangg%20Logo.jpg"
  },
  {
    id: 5,
    slug: "one-door-down",
    name: "One Door Down",
    tagline: "Restaurant · Lounge",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/tu01sdak_OneDoorDown%20Logo.jpg"
  },
  {
    id: 6,
    slug: "romeo-lane",
    name: "Romeo Lane",
    tagline: "The Grand Hyatt · Gurgaon",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/wnb0dcy3_Romeo%20Lane%20Logo.jpg"
  },
  {
    id: 7,
    slug: "zuvaah",
    name: "Zuvaah",
    tagline: "Terrace Bar & Kitchen",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/dftfkdfe_Zuvaah%20Logo.jpg"
  },
  {
    id: 8,
    slug: "dlf-clubs",
    name: "DLF Hospitality",
    tagline: "Clubs · Gurgaon",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/2kf2m7mz_DLF%20Clubs%20Logo.jpg"
  },
  {
    id: 9,
    slug: "red-fox",
    name: "Red Fox by Lemon Tree",
    tagline: "Hotels · Gurgaon",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/hh7qzgk7_Redfox%20Logo.jpg"
  },
  {
    id: 10,
    slug: "swagath",
    name: "Swagath",
    tagline: "Restaurant · Bar",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/3fy6yd3q_Swagath%20Logo.jpg"
  },
  {
    id: 11,
    slug: "barbeque-times",
    name: "The Barbeque Times",
    tagline: "Restaurant",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/gz43pheh_TBT%20Logo.jpg"
  },
  {
    id: 12,
    slug: "beer-circle",
    name: "The Beer Circle",
    tagline: "Bar · Lounge",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/zp4bvk8s_Beer%20Circle%20Logo.jpg"
  },
  {
    id: 13,
    slug: "karma-lakelands",
    name: "Karma Lakelands",
    tagline: "Golf Resort & Residences",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/fpc5ssxy_Karma%20Logo.jpg"
  },
  {
    id: 14,
    slug: "doubletree",
    name: "DoubleTree by Hilton",
    tagline: "Gurugram · Baani Square",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/xsoxglny_DoubleTree%20Logo.jpg"
  },
  {
    id: 15,
    slug: "gonzo",
    name: "Gonzo",
    tagline: "Bar · Kitchen",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/nqk9hsv0_Gonzo.jpg"
  },
  {
    id: 16,
    slug: "689",
    name: "689",
    tagline: "Six Eighty Nine",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/h5ts7wen_689%20Logo.jpg"
  },
  {
    id: 17,
    slug: "yellow-chilli",
    name: "The Yellow Chilli",
    tagline: "Redefining Indian Food",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/mkze01fy_Yellow%20Chilli%20Logo.jpg"
  },
  {
    id: 18,
    slug: "aagaz",
    name: "Aagaz",
    tagline: "Restaurant · Bar",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/m16aqo37_Aagaz%20Logo.jpg"
  },
  {
    id: 19,
    slug: "jamie-oliver",
    name: "Jamie Oliver Kitchen",
    tagline: "Restaurant",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/h1n248od_JO%20Logo.jpg"
  },
  {
    id: 20,
    slug: "breakin-brew",
    name: "Breakin Brew",
    tagline: "Brew Pub",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/6kxq6roo_Breaking%20Brew%20Logo.jpg"
  },
  {
    id: 21,
    slug: "auren",
    name: "Auren",
    tagline: "Restaurant · Lounge",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/6p9sntcn_Auren%20Logo.jpg"
  },
  {
    id: 22,
    slug: "juu-juu",
    name: "Juu Juu",
    tagline: "Restaurant · Bar",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/z5wa0zo0_JUU%20JUU%20Logo.jpg"
  },
  {
    id: 23,
    slug: "heritage-village",
    name: "Heritage Village",
    tagline: "Resorts & Spa · Manesar",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/yrecwl7x_Heritage%20Logo.jpg"
  }
];

// Legacy export — preserved for backward compatibility (combined list)
export const storeLocations = retailStores;
